module.exports = __webpack_public_path__ + "media/components/src/assets/images/what_day/crown1-d33874f2dabe04ef8f405cb3c51fcfaf.png";